<template>
  <router-view/>
</template>

<script setup>
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

#app {
  //width: 100%;
  //height: 100vh;
  overflow: hidden;
  //overflow: auto;
  margin: auto;
  -webkit-tap-highlight-color: transparent;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif !important;

  .el-input__wrapper.is-focus {
    box-shadow: none;
  }

  .cd-input-header > .el-input__wrapper {
    box-shadow: none;
  }
}

.scroll {
  height: 100vh;
}

@media screen and (min-width: 900px) {
  #app {
    width: 500px !important;
  }
}

.login-drawer {
  border-radius: 20px 20px 0 0;

  .el-drawer__header {
    margin-bottom: 10px;
  }
}

.el-dialog.sichuan-airport-info {
  //border-radius: 20px 20px 0 0;
  --el-dialog-border-radius: 30px !important;
  --el-dialog-width: 90% !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    //padding: 15px 10px;
  }
}

.pay-drawer {
  border-radius: 20px 20px 0 0;

  .el-drawer__header {
    margin-bottom: 0 !important;
  }
}

.fcz-product-img {
  position: relative;

  .fcz-product-name {
    position: absolute;
    top: 8%;
    left: 30%;
    color: #7DB4F2;

    &.svip {
      color: #C77717;
    }
  }
}

.recharge_pay_link {
  //渐变色
  background: linear-gradient(90deg, rgba(255, 141, 26, 1), rgba(250, 100, 0, 1));
  border: none !important;
  color: #ffffff !important;
}
</style>
